import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { PageLayoutComponent } from '../page-layout/page-layout.component';
import { PageActionsComponent } from '../page-actions/page-actions.component';
import { BottomNavbarComponent, TitileNavbarComponent } from '../navbar';
import { OrIconComponent } from '../or-icon/or-icon.component';

interface ConnectionErrorContent {
  icon: string;
  title: string;
  message: string;
}

@Component({
  selector: 'lib-connection-error',
  templateUrl: './connection-error.component.html',
  styleUrls: ['./connection-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PageLayoutComponent, PageActionsComponent, TitileNavbarComponent, BottomNavbarComponent, OrIconComponent]
})
export class ConnectionErrorComponent {
  readonly OFFLINE_CONTENT: ConnectionErrorContent = {
    icon: 'no-connection',
    title: 'Brak połączenia z internetem',
    message: 'Wygląda na to, że jesteś offline. Sprawdź Wi-Fi lub dane mobilne i spróbuj ponownie.'
  };

  readonly SERVER_CONTENT: ConnectionErrorContent = {
    icon: 'server',
    title: 'Coś poszło nie tak',
    message: 'Nie udało się połączyć z serwerem. Spróbuj ponownie za chwilę.'
  };

  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  readonly content: Signal<ConnectionErrorContent> = toSignal(
    this.activatedRoute.queryParamMap.pipe(
      map((params: ParamMap) => (params.get('offline') === 'true' ? this.OFFLINE_CONTENT : this.SERVER_CONTENT))
    ),
    { initialValue: this.SERVER_CONTENT }
  );

  retry(): void {
    window.location.href = '/';
  }
}
